export default class Language {
  private static readonly containerId = 'hidden-google-translate';
  private static desiredLanguage = 'en';
  private static loading = false;
  private static initialized = false;
  private static selectObserver: MutationObserver | null = null;

  private static getSelect(): HTMLSelectElement | null {
    return document.querySelector(`#${this.containerId} .goog-te-combo`);
  }

  private static applyLanguage(): boolean {
    const select = this.getSelect();
    if (!select?.querySelector(`option[value="${this.desiredLanguage}"]`)) return false;

    if (select.value !== this.desiredLanguage) {
      select.value = this.desiredLanguage;
      select.dispatchEvent(new Event('change'));
    }
    return true;
  }

  private static waitForSelect(container: HTMLElement) {
    if (this.applyLanguage()) {
      this.selectObserver?.disconnect();
      this.selectObserver = null;
      return;
    }
    if (this.selectObserver) return;

    this.selectObserver = new MutationObserver(() => {
      if (this.applyLanguage()) {
        this.selectObserver?.disconnect();
        this.selectObserver = null;
      }
    });
    this.selectObserver.observe(container, { childList: true, subtree: true });
  }

  static setLanguage(language: string) {
    this.desiredLanguage = language;

    // English is the source page. Reload only if Google already translated this tab.
    if (language === 'en') {
      if (this.initialized || this.loading) window.location.reload();
      return;
    }

    if (this.initialized) {
      this.waitForSelect(document.getElementById(this.containerId)!);
      return;
    }
    if (this.loading) return;

    this.loading = true;
    // Google calls this function after loading its script.
    (window as any).googleTranslateElementInit = () => {
      this.initialized = true;
      this.loading = false;

      let container = document.getElementById(this.containerId);
      if (!container) {
        container = document.createElement('div');
        container.id = this.containerId;
        container.style.display = 'none';
        document.body.appendChild(container);
      }

      new (window as any).google.translate.TranslateElement(
        { pageLanguage: 'en', autoDisplay: false },
        container.id
      );
      this.waitForSelect(container);
    };

    if ((window as any).google?.translate?.TranslateElement) {
      (window as any).googleTranslateElementInit();
    } else {
      const script = document.createElement('script');
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      script.onerror = () => { this.loading = false; };
      document.body.appendChild(script);
    }
  }
}
